<template>
    <b-modal
        v-model="shown"
        centered
        :title="title"
        lazy
    >
        <Spinner v-if="loading" />
        <b-container
            v-else
            fluid
        >
            <b-row>
                <b-form-group class="mb-0 w-100">
                    <Select
                        v-model="selectedTaxRate"
                        placeholder="Select a tax rate..."
                        action="selects/getTaxRates"
                        :cache="true"
                    />
                    <b-form-invalid-feedback :force-show="$v.selectedTaxRate.$dirty && !$v.selectedTaxRate.required">
                        Please select a tax rate.
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-row>
        </b-container>
        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="handleClose"
            >
                Close
            </b-btn>
            <Button
                variant="success"
                :disabled="loading || $v.$invalid"
                :loading="submitLoading"
                @click="handleSubmit"
            >
                Save
            </Button>
        </div>
    </b-modal>
</template>

<script>
import required from 'vuelidate/lib/validators/required';
import vueComponentReset from '@ianwalter/vue-component-reset';

const resetMixin = vueComponentReset(() => ({
    shown: false,
    loading: false,
    submitLoading: false,
    selectedTaxRate: null,
}));

export default {

    mixins: [
        resetMixin,
    ],

    computed: {
        selectedCostIds() {
            return this.$store.getters['costable/selectedCostIds'];
        },
        title() {
            return `Change tax rate of ${this.selectedCostIds.length} Costs`;
        },
    },

    created() {
        this.$eventBus.$on(this.$events.openChangeTaxRateModal, () => {
            this.$v.$reset();
            this.reset();
            this.shown = true;
        });
    },

    methods: {
        async handleSubmit() {
            this.submitLoading = true;
            await this.$store.dispatch('costable/patchCosts', {
                costIds: this.selectedCostIds,
                data: { tax_rate_id: this.selectedTaxRate.id },
            });
            this.submitLoading = false;
            this.handleClose();
        },
        handleClose() {
            this.shown = false;
        },
    },

    validations: {
        selectedTaxRate: {
            required,
        },
    },

};
</script>
